const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Menu = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domHeader: $('.js-site-header'),
	$domMenuBtn: $('.js-menu-btn'),
	$domMenuOuter: $('.js-nav-outer'),
	$domMenuInner: $('.js-nav-inner'),
	$domMenuIcon: $('.js-nav-icon'),
	$domMenuSub: $('.sub-menu'),
	$domHeaderBtns: $('.js-site-header-btns'),
	slMenuIcon: '.js-nav-icon',
	slMenuSub: '.sub-menu',
	classActive: 'is-active',
	timeout: null,

	/** @description Initialize */
	init: function() {
		this.bindEvents();
		this.appendItems();

		document.querySelectorAll('.menu-item a').forEach(function(link) {
			if (link.getAttribute('href') && link.getAttribute('href').includes('#')) {
				link.classList.add('no-link');
			}
		});
	},

	/** @description Bind Events */
	bindEvents: function() {
		const $ignoreClose = $('.js-nav-inner, .gt-lang-code, .gt_float_switcher-arrow, .gt-current-lang, .site-header__top');
		this.$domMenuBtn.on('click', this.toggleMenu.bind(this));
		this.$domMenuIcon.on('click', this.toggleSubMenu.bind(this));
		Global.escKey(this.closeMenu.bind(this));
		if ($(window).width() < 1200) {
			Global.clickOutsideContainer(Global.$domBody, $ignoreClose, this.$domMenuBtn, this.closeMenu.bind(this));
		}
	},

	toggleMenu: function() {
		if (!this.$domMenuBtn.hasClass(this.classActive)) {
			this.$domMenuBtn.addClass(this.classActive);
			this.$domMenuOuter.addClass(this.classActive);
			this.$domHeader.addClass('active');
			$(document.body).addClass('overflow-active');
			Menu.appendLanguage();
		} else {
			this.closeMenu();
			this.$domHeader.removeClass('active');
			$(document.body).removeClass('overflow-active');
		}
	},

	toggleSubMenu(e) {
		const icon = $(e.target).closest(this.slMenuIcon);
		const ul = icon.siblings(this.slMenuSub);

		if (!icon.hasClass(this.classActive)) {
			icon.addClass(this.classActive);
			ul.slideDown();
		} else {
			icon.removeClass(this.classActive);
			icon.parent().find(this.slMenuIcon).removeClass(this.classActive);
			ul.slideUp();
			ul.find(this.slMenuSub).slideUp();
		}
	},

	closeMenu: function() {
		Menu.returnLanguage();
		this.$domMenuBtn.removeClass(this.classActive);
		this.$domMenuOuter.removeClass(this.classActive);
		this.$domHeader.removeClass('active');
		$(document.body).removeClass('overflow-active');

		// timeout should match the selectors CSS transition duration property
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.$domMenuIcon.removeClass(this.classActive);
			this.$domMenuSub.slideUp();
		}, 300);
	},

	appendItems: function() {
		if ($(window).width() < 992) {
			this.$domMenuInner.append(this.$domHeaderBtns);
		}
		$(window).resize(function() {
			if ($(window).width() < 992) {
				Menu.$domMenuInner.append(Menu.$domHeaderBtns);
			} else {
				if ($('.js-nav-inner .js-site-header-btns:not(.site-header__top-col)').length) {
					$('.site-header__container').append($('.js-site-header-btns:not(.site-header__top-col)'));
				}
				if ($('.js-nav-inner .js-site-header-btns.site-header__top-col').length) {
					$('.site-header__top-row').prepend($('.js-site-header-btns.site-header__top-col'));
				}
			}
		});
	},

	appendLanguage: function() {
		this.$domMenuInner.append($('.js-header-language-switcher'));
	},

	returnLanguage: function() {
		$('.site-header__top-row').append($('.js-header-language-switcher'));
	}
};

export default Menu;
